import * as parentConstants from 'modules/client-admin/ClientsPage/constants';
import lazyWithSuspense from 'modules/lazyWithSuspense';
import makePage from 'modules/makePage';
import Page from 'modules/Page';
import { DEFAULT_SHORT_DATE_CONFIG, displayTemporal } from 'utils';
import { i18n } from 'i18n';
import * as constants from './constants';
import { EditBinderCostRecordPageParams } from './constants';
import useEditBinderCostRecordQueries, { EditBinderCostRecordQueries } from './useEditBinderCostRecordQueries';

const EditBinderCostRecordPage = lazyWithSuspense(() => import('./EditBinderCostRecordPage'));

const page: Page = {
  title: constants.TITLE,
  routeProps: {
    path: constants.ROUTE_PATH,
  },
  component: makePage<EditBinderCostRecordPageParams, EditBinderCostRecordQueries>({
    WrappedPage: EditBinderCostRecordPage,
    titleFn: ([binderCostRecord]) => (binderCostRecord.data ? i18n._(displayTemporal(binderCostRecord.data.purchaseDate, DEFAULT_SHORT_DATE_CONFIG)) : ''),
    parentPathTemplate: parentConstants.ROUTE_PATH,
    parentTitleFn: () => i18n._(parentConstants.TITLE),
    pageDataHook: useEditBinderCostRecordQueries,
  }),
};

export default page;
